var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('el-button',{staticClass:"getNumber",style:(_vm.countdownStyle),attrs:{"disabled":_vm.disabled},on:{"click":_vm.getCode}},[_vm._v(" "+_vm._s(this.countDownType === 'reg' ? _vm.codeMsg: '登录')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }